<template>
  <div>
    <div class="row border-bottom border-2 p-2">
      <div class="col-sm-5"></div>
      <div class="col-sm-7 profil-border-left">
        <h6>{{trans('passwords.update.enter_password')}}</h6>
        <input
          v-model="newPassword"
          name="password"
          type="password"
          class="email required"
          required
        />
      </div>
    </div>
    <div class="row border-bottom border-2 p-2">
      <div class="col-sm-5"></div>
      <div class="col-sm-7 profil-border-left">
        <h6>{{trans('passwords.update.confirm_password')}}</h6>
        <input
          v-model="confirmPassword"
          name="password2"
          type="password"
          class="email required"
        >
      </div>
    </div>
    <div class="row border-bottom border-2 p-2">
      <div class="col-sm-5"></div>
      <div class="col-sm-7 profil-border-left">
        <div class="form-group row py-2 pb-4">
          <div class="col p-0">
            <button
              type="submit"
              class="btn btn-primary"
              @click="changePassword"
              :disabled="!valid"
            >
              {{trans('passwords.update.update_password')}}
            </button>
            <div v-if="error" class="error alert alert-danger p-1 mt-2">
              <span v-if="error==='rule'">{{trans('passwords.update.error.rule')}}</span>
              <span v-if="error==='confirm'">{{trans('passwords.update.error.confirm')}}</span>
            </div>
            <div v-if="successMessage" class="alert alert-success p-1 mt-2">
              {{trans('passwords.update.has_saved')}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChangePasswordComponent',
  data: function () {
    return {
      newPassword: null,
      confirmPassword: null,
      valid: false,
      error: '',
      pattern: '',
      successMessage: false,
    };
  },
  watch: {
    newPassword() {
      this.checkPassword();
    },
    confirmPassword() {
      this.checkPassword();
    },
  },
  methods: {
    changePassword: function () {
      axios.post('/my/change_password', {password: this.newPassword})
        .then((resp) => {
          if (resp.status === 200) {
            location.href = '/login?mode=after_change';
          }
        });
    },

    checkPassword() {
      this.successMessage = this.successMessage && !this.newPassword && !this.confirmPassword
      this.valid = false;
      this.error = '';
      if (this.newPassword && !this.checkPattern(this.newPassword)) {
        debugger
        this.error = 'rule';
        return;
      }
      if (this.newPassword && this.confirmPassword) {
        if (this.newPassword !== this.confirmPassword) {
          debugger
          this.error = 'confirm';
          return;
        }
        this.valid = true
      }

    },

    checkPattern(value) {
      const pattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,64}$';
      return value.match(pattern);
    },
  }
}
</script>
<style scoped>

</style>
